import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile, isTablet } from "../../../@css-style";

export const ElBanner = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  ${String(isMobile)} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  ${String(isMobile)} {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ElContentColumn = styled.div`
  width: 24.999%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  background-color: var(--theme-main-color);
  height: 100%;
  border-radius: 5px;
  ${String(isMobile)} {
    width: 100% !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ElOdoBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* gap: 20px; */
  /* padding: 10px; */
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 2em;
`;

export const elShadow = css`
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  padding: 20px; */
`;

export const ElValue = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--theme-main-flat-color);
  transition: all 0.4s ease;
  text-transform: none;
  letter-spacing: normal;
  font-size: 36px;
  font-weight: 700;
  ${String(isTablet)} {
    font-size: 25px;
  }
`;

export const ElHeadLine = styled.h1`
  display: flex;
  text-align: left;
  font-size: 36px;
  width: 100%;
  font-weight: 600;
  color: var(--theme-main-flat-dark-color);
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  background-color: transparent;
  /* background-image: linear-gradient(45deg, #10575c 0%, #297b10 100%); */
`;

export const ElTitle = styled.p`
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: var(--theme-main-flat-color);
  line-height: 1.6em;
`;

export const ElSubTitle = styled.p`
  width: 100%;
  text-align: left;
  font-size: 17px;
  font-weight: 400;
  color: var(--theme-main-flat-dark-color);
`;

export const ElpoweredImage = styled.img`
  width: 80%;
`;

export const elGapBanner = css`
  gap: 20px;
`;

export const ElAnchorButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--theme-hover-color);
  border: 1px solid var(--theme-main-color);
  background-color: var(--theme-main-flat-color);
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  padding: 12px 24px;
  border-radius: 3px;
  &:hover {
    color: var(--theme-main-flat-color);
    background-color: var(--theme-hover-color);
  }
`;
